<template>
  <v-avatar :color="image ? '' : 'primary'" class="white--text" :size="small ? 32 : 48">
    <v-img :alt="name" :src="image" v-if="image">
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="secondary"
          />
        </v-row>
      </template>
    </v-img>

    <span
      class="font-sans"
      :class="small ? 'text-sm' : 'text-xl'"
      v-else-if="initials"
    >
      {{ initials }}
    </span>

    <img alt="Perfil" src="~@/assets/img/habitat.png" v-else />
  </v-avatar>
</template>

<script>
export default {
  name: 'ProfileImage',

  props: {
    name: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      default: null,
    },
    small: Boolean,
  },

  computed: {
    initials() {
      return this.name
        ?.split(' ')
        .slice(0, 2)
        .map(s => s.charAt(0))
        .join('');
    },
  },
}
</script>